"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.affiliationPathFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.affiliationPathFactory = Factory.Sync.makeFactory([
    {
        classification: 'Club',
        organization_id: Mocks.orgClub.id,
        organization_name: Mocks.orgClub.name,
    },
    {
        classification: null,
        organization_id: Mocks.orgNgb.id,
        organization_name: Mocks.orgNgb.name
    },
]);
